import React from 'react'
import Sdata from './Sdata'
import Cards from './Cards'

const Service = () => {
    return (
        <>
        <div className="service">
            <div className="service__1">
            <h1>Service</h1>
            <p>There are service. I provide you</p>
            </div>
            <div className="container">
            <div className="row gy-4">
           
{Sdata.map((val,ind)=>{
return <Cards
key={ind}
imgsrc={val.imgsrc}
/>

})
}
            </div>
            </div>

            
        </div>
        </>
    )
}

export default Service
